import './index.less'
import { addItem } from '@shopify/theme-cart';
import { calcTop, isMobile } from '@utils/index.js'
import { getProductInfo } from "@utils/fetch.js";
import { createApp } from 'vue/dist/vue.esm-browser.js';
const listInfo = {}
$('.blog-product-item').each(function () {
    if ($(this).data('product-id')) {
        Object.assign(listInfo, {
            [$(this).data('product-id')]: {
                id: $(this).data('product-id'),
                title: $(this).data('title'),
                description: $(this).data('description'),
                clas: $(this).data('clas')
            }
        })
    }
})

window.$(document).ready(function () {
    const vm = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                originList: listInfo,
                pageShareUrl: window.location.href,
                productList: [],
                flag: false,
                isMobile: isMobile()
            }
        },
        async mounted() {
            this.flag = $('.new-article-main').data('flag')
            $('.new-article-main-right').css({ top: `${calcTop() + 30}px` })
            await this.getProductList()
            this.init()
        },
        methods: {
            init() {
                const that = this
                $('.add-to-cart').click(function () {
                    $(this).addClass('btn--loading')
                    const id = $(this).data('id')
                    const sku = $(this).data('sku')
                    that.addToCart(+id, {}, sku)
                })
                $('.learn-more').click(function () {
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Product Display",
                        position: $(this).data('title'),
                        button_name: $(this).text().trim(),
                        link: $(this).data('url')
                    }
                    that.handleGa(gaParams)
                    const flag = $('.new-article-header').data('new-blank')
                    const url = $(this).data('url')
                    if (flag) {
                        window.open(url)
                    } else {
                        window.location.href = url
                    }
                })
                $('.article-type').click(function () {
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Type&Label ",
                        position: $(this).text().trim(),
                        link: $(this).attr('href')
                    }
                    that.handleGa(gaParams)
                })

                // 关联文章
                $('.related-article').click(function () {
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Related Articles",
                        position: $(this).text().trim(),
                        link: $(this).attr('href')
                    }
                    that.handleGa(gaParams)
                })
                // 广告位
                $('.article-image').click(function () {
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Right_pic",
                        position: 'sing_pic',
                        link: $(this).attr('href')
                    }
                    that.handleGa(gaParams)
                })

                // Shop products from this article
                $('.shop-product').click(function () {
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Bottom Product",
                        position: $(this).text().trim(),
                        link: $(this).attr('href')
                    }
                    that.handleGa(gaParams)
                })

                $('.swiper-button-prev-new').click(function () {
                    const index = $(this).data('index')
                    const swiperEl = document.querySelector(`.swiper-${index}`);
                    swiperEl.swiper.slidePrev();
                })

                $('.swiper-button-next-new').click(function () {
                    const index = $(this).data('index')
                    const swiperEl = document.querySelector(`.swiper-${index}`);
                    swiperEl.swiper.slideNext();
                })

            },
            async handleProduct() {
                const keys = Object.keys(this.originList)
                const productList = []
                const fetchApi = []
                keys.forEach(async id => {
                    fetchApi.push(getProductInfo({ spuId: id }))
                })

                const res = await Promise.allSettled(fetchApi)
                res.forEach(item => {
                    const { status, value } = item
                    if (status === 'fulfilled') {
                        const { code, data } = value
                        if (code === 200 && data !== null) {
                            const { product: { id, images, body_html, title, status, handle, variants } } = data
                            productList.push({
                                id,
                                images,
                                title,
                                description: body_html,
                                url: `/products/${handle}`,
                                variants,
                                clas: this.originList[id].clas
                            })
                        }
                    }
                })

                return productList
            },
            // 获取产品信息
            async getProductList() {
                const productList = await this.handleProduct()
                productList.forEach((item, index) => {
                    let html = ''
                    // 当只有一个变体时，需要判断是否有效
                    const length = item.variants.length

                    // flag为true则表示有效 false表示无效
                    let flag = true
                    if (length === 1) {
                        const { inventory_quantity, inventory_policy, inventory_management } = item.variants[0]
                        flag = inventory_quantity > 0 || inventory_policy === 'continue' || !inventory_management
                    }
                    const clas = flag ? 'bg-#FD5000 hover:opacity-60' : 'bg-#FD5000cc cursor-not-allowed'
                    const disabled = flag ? '' : 'disabled'
                    const btn = item.variants.length > 1 ? `
                        <div 
                            class="flex-center rounded-100 Poppins-SemiBold font-600 color-#FD5000 border border-#FD5000 cursor-pointer mt-40 px-40 h-80 text-26 lg:a-mt-30 lg:a-px-32 lg:a-h-48 lg:a-text-18 hover:lg:bg-#FD5000 hover:lg:text-#fff learn-more"
                            data-url="${item.url}"
                            data-id="${item.id}"
                            data-title="${item.title}"
                        >
                            ${$('.new-article-header').data('learn-more')}
                        </button>
                    ` : `
                        <button
                            class="product-left-btn flex-center rounded-100 Poppins-SemiBold font-600 color-#FD5000 border border-#FD5000 cursor-pointer mt-40 px-40 h-80 text-26 mr-16 lg:a-mr-16 lg:a-mt-30 lg:a-px-32 lg:a-h-48 lg:a-text-18 hover:lg:bg-#FD5000 hover:lg:text-#fff learn-more"
                            data-url="${item.url}"
                            data-id="${item.id}"
                            data-title="${item.title}"
                        >
                            ${$('.new-article-header').data('learn-more')}
                        </button>
                        <button
                            class="flex-center rounded-100 Poppins-SemiBold font-600 color-#fff cursor-pointer mt-40 px-40 h-80 text-26 lg:a-mt-30 lg:a-mt-0 lg:a-px-32 lg:a-h-48 lg:a-text-18  add-to-cart ${clas}"
                            data-id="${item.variants[0].id}"
                            data-sku="${item.variants[0].sku}"
                            data-title="${item.title}"
                            data-add-to-cart
                            ${disabled}
                        >
                            ${$('.new-article-header').data('add-to-cart')}
                        </button>
                    `
                    let slideHtml = ''
                    item.images.forEach(img => {
                        slideHtml += `
                            <swiper-slide>
                                <a href="${item.url}" target="_blank">
                                <img class="w-670 h-670 lg:a-w-380 lg:a-h-380" src="${img.src}" alt="${img.alt}">
                                </a>
                            </swiper-slide> 
                        `
                    })

                    html += `
                        <div class="lg:flex justify-between mb-60 lg:a-mb-16 article-product">
                            <a href="${item.url}" target="_blank" class="mobile-block">
                                <div class="Poppins-SemiBold font-600 color-#333333 text-34 leading-50 lg:a-text-24 lg:a-leading-32 line-clamp-3">${this.originList[item.id].title || item.title}</div>
                            </a>
                            <div class="swiper-content">
                                <swiper-container
                                    class="w-full lg:a-w-380 swiper-${index}"
                                    loop="true"
                                    pagination="true"
                                    autoplay-delay="5000"
                                    autoplay-disable-on-interaction="false"
                                    pagination-type="fraction"
                                    style="
                                        --swiper-navigation-color: #a5a4a4; 
                                        --swiper-pagination-color: #FD5000; 
                                    "
                                >
                                    ${slideHtml}
                                    <div class="h-60 lg:a-h-34" slot="container-start"></div>
                                    <div class="h-60 lg:a-h-34" slot="container-end"></div>
                                </swiper-container>
                                <div class="swiper-buttons">
                                    <button data-index="${index}" class="swiper-button swiper-button-prev-new"><i class="iconfont jackery-icon-left"></i></button>
                                    <button data-index="${index}" class="swiper-button swiper-button-next-new"><i class="iconfont jackery-icon-right"></i></button>
                                </div>
                            </div>
                            <div class="lg:a-w-380 mt-60 lg:a-mt-34 lg:a-mb-34 lg:flex flex-col justify-between swiper-bottom">
                                <div>
                                    <a href="${item.url}" target="_blank" class="pc-block">
                                        <div class="Poppins-SemiBold font-600 color-#333333 text-34 leading-50 lg:a-text-24 lg:a-leading-32 line-clamp-3">${this.originList[item.id].title || item.title}</div>
                                     </a>
                                    <div class="Poppins-Medium swiper-des mt-14 text-26 leading-38 lg:a-text-16 font-500 lg:a-leading-24 color-#666 lg:a-mt-13 line-clamp-7 product-${index}-description">
                                        ${this.handleReg(this.originList[item.id].description) || item.description}
                                    </div>
                                </div>
                                <div class="flex items-center flex-wrap justify-center lg:justify-start">
                                    ${btn}
                                </div>
                            </div>
                        </div>
                    `
                    $(`.${item.clas}`).append(html)
                });
            },
            handleReg(text) {
                if (!text) return ''
                return text.replace(/(\r\n)|(\n)/g, '<br>')
            },
            openWindows(url) {
                window.open(
                    url,
                    "单独窗口",
                    "height=300,width=600,top=30,left=20,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no"
                );
            },
            copyFunc(copyContent) {
                if (navigator.clipboard) {
                    // clipboard api 复制
                    navigator.clipboard.writeText(copyContent);
                } else {
                    var textarea = document.createElement('textarea');
                    document.body.appendChild(textarea);
                    // 隐藏此输入框
                    textarea.style.position = 'fixed';
                    textarea.style.clip = 'rect(0 0 0 0)';
                    textarea.style.top = '10px';
                    // 赋值
                    textarea.value = copyContent;
                    // 选中
                    textarea.select();
                    // 复制
                    document.execCommand('copy', true);
                    // 移除输入框
                    document.body.removeChild(textarea);
                }
            },
            socialShareFunc(type) {
                switch (type) {
                    case 'Instagram':
                        this.copyFunc(this.pageShareUrl);
                        pushSuccessMessage($('.new-article-header').data('share-successful'), 5000);
                        break;
                    case 'email':
                        window.location = "mailto:?subject=&cc=&body=";
                        break;
                    default:
                        const shareUrl = this.getSocialShareAPI(type);
                        this.openWindows(shareUrl);
                        break;
                }
                const gaParams = {
                    title: $('.new-article-header').data('title'),
                    module: "Blog Share",
                    position: type,
                }
                this.handleGa(gaParams)
            },
            /**
             * 各社交平台分享插件调用
             * @param {string} type 社交平台
             */
            getSocialShareAPI(type) {
                let url = '';
                let pageTitle = $("meta[property='og:title']").attr("content");
                const updateTime = Date.now();
                const endShareUrl = `${this.pageShareUrl}?t=${updateTime}`;
                switch (type) {
                    case "facebook":
                        url = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(endShareUrl);
                        break;
                    case "twitter":
                        url = `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(this.pageShareUrl)}&ref_src=${encodeURIComponent("twsrc^tfw|twcamp^buttonembed|twterm^share|twgr^")}&text=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(`${endShareUrl}`)}`;
                        break;
                    case "WhatsApp":
                        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(endShareUrl)}`;
                        break;
                    case "Line":
                        url = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(`${endShareUrl}`)}`;
                        break;
                    default:
                        url = '';
                        break;
                }
                return url;
            },
            // 添加到购物车
            async addToCart(id, properties = {}, sku) {
                if (!id) return
                let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                try {
                    const res = await addItem(id, { quantity: 1, properties, })
                    const gaParams = {
                        title: $('.new-article-header').data('title'),
                        module: "Blog Product Display",
                        position: sku,
                        button_name: $('.add-to-cart:eq(0)').text().trim(),
                    }
                    this.handleGa(gaParams)
                    if (cart) {
                        cart.renderContents(res)
                    } else {
                        window.location.href = '/cart'
                    }
                } catch (e) {
                    const err = await e.json()
                    pushErrorMessage(err.description, 3000)
                } finally {
                    if (cart && cart.classList.contains('is-empty'))
                        cart.classList.remove('is-empty')
                    document.querySelectorAll('[data-add-to-cart]').forEach(it => it.classList.remove('btn--loading'))
                }
            },
            handleGa(params) {
                window.dataLayer.push({ "event_parameters": null });
                window.dataLayer.push({
                    event: "ga4Event",
                    event_name: "blog_detail_page_user_clicks",
                    event_parameters: {
                        "current_page": window.location.href,
                        ...params
                    }
                });
            },
        }
    }).mount('#article-new')
    new ArticleMain('#article-new');
})


class ArticleMain {
    constructor(id) {
        this.id = id;
        this.el = document.querySelector(this.id);
        this.DOM = {
            articleMain: this.el.querySelector('.new-article-main'),
            tableContent: this.el.querySelector('.table-content'),
        }
        this.data = {
            isShowH3: this.DOM.articleMain.dataset.showH3 === 'true',
            contentResult: [], // 存储标题
            productSwipersCount: Number(this.DOM.articleMain.dataset.productSwipersCount)
        }
        this.checked = false;

        this.init()
    }
    init() {
        // 等待页面加载完成
        this.handleContent()
        this.bindEvents();
        this.subscribe()
        this.handleCalculator()
        this.gaRandomButton()
        if (this.data.productSwipersCount > 0) {
            this.handleProductSwipers();
        }
    }

    gaRandomButton() {
        document.querySelectorAll('.article-button a').forEach((el) => {
            el.addEventListener('click', function (e) {
                const title = $('#article-new h1').text().trim() || '';
                const button_name = this.textContent.trim() || '';
                const link = this.href || '';
                let params = {
                    title,
                    button_name,
                    link,
                    module: "Blog Button"
                };

                window.dataLayer.push({ event_parameters: null });
                window.dataLayer.push({
                    event: 'ga4Event',
                    event_name: 'blog_detail_page_user_clicks',
                    event_parameters: {
                        current_page: window.location.href, // current page url
                        ...params,
                    },
                });

            });
        });
    }

    // 处理日本计算器逻辑，dom结构手动插入进去的，下面有判断有dom结构，再执行函数
    handleCalculator() {
        const calculatorDiv = document.getElementById('electric-calculator');
        if (calculatorDiv) {
            const tabs = document.querySelectorAll(".tab");
            const contents = document.querySelectorAll(".tab-content");

            tabs.forEach(tab => {
                tab.addEventListener("click", () => {
                    tabs.forEach(t => t.classList.remove("active"));
                    contents.forEach(c => c.classList.remove("active"));
                    tab.classList.add("active");
                    document.getElementById(tab.dataset.target).classList.add("active");
                });
            });

            document.getElementById("btn-current-to-power").addEventListener("click", function () {
                const current = parseFloat(document.getElementById("current-value").value);
                const unit = document.getElementById("current-unit").value;
                const voltage = parseFloat(document.getElementById("voltage-current").value);
                const result = document.getElementById("power-result");

                if (isNaN(current) || isNaN(voltage)) {
                    result.textContent = "有効な数値を入力してください";
                    return;
                }

                const amps = unit === "mA" ? current / 1000 : current;
                const watts = amps * voltage;
                const kW = watts / 1000;

                result.textContent = `${current} ${unit} × ${voltage}V = ${watts.toFixed(3)}W (${kW.toFixed(3)}kW)`;
            });

            document.getElementById("btn-power-to-current").addEventListener("click", function () {
                const power = parseFloat(document.getElementById("power-value").value);
                const unit = document.getElementById("power-unit").value;
                const voltage = parseFloat(document.getElementById("voltage-power").value);
                const result = document.getElementById("current-result");

                if (isNaN(power) || isNaN(voltage) || voltage === 0) {
                    result.textContent = "有効な数値を入力してください（電圧≠0）";
                    return;
                }

                const watts = unit === "kW" ? power * 1000 : power;
                const amps = watts / voltage;
                const mA = amps * 1000;

                result.textContent = `${power} ${unit} ÷ ${voltage}V = ${amps.toFixed(3)}A (${mA.toFixed(1)}mA)`;
            });
        }
    }

    handleEmail() {
        this.email = document.querySelector('.subscribe-main input[type=email]');
        this.email_error = document.querySelector('.subscribe-main .form-emai-error');
        this.email_error_span = document.querySelector('.subscribe-main .form-emai-error span');
        this.email_error.classList.remove('error');
        const value = this.email.value;

        if (!value) {
            this.email_error_span.innerText =
                $('.subscribe-main .form-emai-error').data('require') || 'Enter Your Email Address';
            this.email_error.classList.add('error');
            return false;
        }

        if (value.indexOf('@') === -1) {
            this.email_error_span.innerText =
                $('.subscribe-main .form-emai-error').data('rule') || 'Enter Correct Email Address';
            this.email_error.classList.add('error');
            return false;
        }
        return true;
    }

    handlePolicy() {
        this.checkbox = document.querySelector('.subscribe-main input[type=checkbox]');
        this.checkbox_error = document.querySelector('.subscribe-main .pf-checkbox-error');
        this.checkbox_error.classList.remove('error');
        const value = this.checkbox.checked;
        if (!value) {
            this.checkbox_error.classList.add('error');
            return false;
        }
        return true;
    }

    handleSubscribe(email) {
        const tags = $('#article-new .subscribe-main .newbee-form_submit button').data('tag');
        const bodyData = {
            email,
            shopify_shop_id: window.pageInfo.shopId,
            componentName: "博客订阅",
            pageUrl: window.location.href
        };

        if (tags) {
            bodyData.tags = tags;
        }
        fetch(`${window.pageInfo.api}/osconsumerapi/v1/notice/subscribe`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                cr: window?.pageInfo?.cr,
                lang: window?.pageInfo?.lang,
            },
            body: JSON.stringify(bodyData),
        })
            .then((response) => response.json())
            .then((res) => {
                if (res.code === 200) {
                    const msg = $('.subscribe-main .newbee-form_submit button').data('success') || res.message;
                    window?.pushSuccessMessage(msg);
                    document.querySelector('.subscribe-main input[type=email]').value = ''

                    //埋码
                    const title = $('#article-new h1').text().trim() || '';
                    const position = $('#article-new .subscribe-title').text().trim() || '';
                    const button_name = $('#article-new .newbee-form_submit button').text().trim() || '';
                    let params = {
                        title,
                        position,
                        button_name,
                        module: "Subscribe Submit"
                    };

                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                        event: 'ga4Event',
                        event_name: 'blog_detail_page_user_clicks',
                        event_parameters: {
                            current_page: window.location.href, // current page url
                            ...params,
                        },
                    });

                } else {
                    window?.pushErrorMessage(res.message || 'Network Error');
                }
            })
            .catch((e) => {
                window?.pushErrorMessage(e);
            });
    }

    subscribe() {
        this.submit = document.querySelector('.subscribe-main button');
        this.form = document.querySelector('.subscribe-main form');
        this.email = document.querySelector('.subscribe-main input[type=email]');
        this.checkbox = document.querySelector('.subscribe-main input[type=checkbox]');
        this.submit.addEventListener('click', (e) => {
            e.preventDefault();
            const r_2 = this.handleEmail();
            const r_1 = this.handlePolicy();
            if (r_1 && r_2) {
                this.handleSubscribe(this.email.value);
            }
        });

        this.email.addEventListener('blur', (e) => {
            this.handleEmail()
        });

        this.email.addEventListener('input', (e) => {
            this.handleEmail();
        });

        this.checkbox.addEventListener('change', (e) => {
            this.handlePolicy();
        });

    }

    /**
     * @description 处理文章内容，提取H2和H3标题，并生成层级结构
     */
    handleContent() {
        const el = this.data.isShowH3 ? '.article__body h2, .article__body h3' : '.article__body h2';
        const headers = Array.from(document.querySelectorAll(el))
            .sort((a, b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
        // 存储结果的结构化数据
        const result = [];
        let currentH2 = null;
        headers.forEach((header, index) => {
            if (header.tagName === 'H2') {
                header.dataset.priv = `article-priv-${index}`; // 添加类名
                // 创建新的H2条目
                currentH2 = { text: header.textContent, el: header, children: [] };
                result.push(currentH2);
            } else if (this.data.isShowH3 && header.tagName === 'H3' && currentH2 !== null) {
                header.dataset.priv = `article-priv-${index}`; // 添加类名
                // 将H3添加到当前H2的子级
                currentH2.children.push({
                    text: header.textContent,
                    el: header,
                });
            }
        });
        // 将结果插入到页面中
        const tableContent = this.DOM.tableContent || null;
        if (tableContent && result.length > 0) {
            this.data.contentResult = result; // 保存结果到data中
            let html = ``
            result.forEach((item, index) => {
                html += `
                    <div class="artcile-h2 artcile-content-link" data-priv="${index}"> ${item.text} </div>
                `
                // 如果需要显示H3标题
                if (this.data.isShowH3 && item.children.length > 0) {
                    let h3Element = ``;
                    item.children.forEach((child, j) => {
                        h3Element += `
                            <div class="artcile-h3 artcile-content-link" data-priv="${index + j + 1}"> ${j + 1}. ${child.text} </div>
                        `
                    });
                    html += `
                        <div class="artcile-h3-container"> ${h3Element} </div>
                    `
                }
            })
            tableContent.innerHTML = html;
        }

        // 判断当前文本内容是否大于最大高度
        const tableContentHeight = tableContent.scrollHeight || 0;
        const tableContentMaxHeight = $('.table-content').css('max-height');
        const maxHeightValue = parseInt(tableContentMaxHeight, 10);
        if (tableContentHeight > maxHeightValue) {
            $('.article-view-more').css({ display: 'flex' });
        } else {
            $('.article-view-more').hide();
        }

    }
    /**
     * @description 绑定事件
     */
    bindEvents() {
        $('.table-content').on('click', '.artcile-content-link', function () {
            const priv = $(this).data('priv')
            $('html, body').animate({
                scrollTop: $(`[data-priv='article-priv-${priv}']`).offset().top - calcTop() - 30
            }, 300);
        })

        // 点击View More
        $('.article-view-more').click(function () {
            $('.table-content').css({ maxHeight: 'max-content' })
            $(this).remove();
        })
    }
    /**
     * @description 处理产品轮播
     */
    handleProductSwipers() {
        for (let i = 0; i < this.data.productSwipersCount; i++) {
            const swiperEl = document.querySelector(`.product-swiper-${i + 1}`);
            const insetClass = swiperEl?.dataset.swiperClass || ''
            const insetEl = document.querySelector(`.${insetClass}`) || null;
            if (swiperEl && insetEl) {
                const length = swiperEl.querySelectorAll('.swiper-slide').length;
                const navigationFlag = isMobile() ? length > 2 : length > 4;
                new Swiper(swiperEl, {
                    spaceBetween: 12,
                    slidesPerView: 2.2,
                    breakpoints: {
                        1024: {
                            spaceBetween: 16,
                            slidesPerView: 4
                        },
                    },
                    // loop: true,
                    pagination: {
                        el: `.product-swiper--pagination-${i + 1}`,
                        clickable: true,
                    },
                    navigation: navigationFlag ?  {
                        nextEl: `.product-swiper--next-${i + 1}`,
                        prevEl: `.product-swiper--prev-${i + 1}`,
                    } : false,
                });
                insetEl.appendChild(swiperEl);

                if (navigationFlag) {
                    $(`.product-swiper--next-${i + 1}`).css({ display: 'flex' });
                    $(`.product-swiper--prev-${i + 1}`).css({ display: 'flex' });
                }
            }
        }
    }
}
